module.exports = __webpack_public_path__ + "img/face_id_border.0f444cae.svg";